var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.30775 15.5C1.80258 15.5 1.375 15.325 1.025 14.975C0.675 14.625 0.5 14.1974 0.5 13.6923V2.30775C0.5 1.80258 0.675 1.375 1.025 1.025C1.375 0.675 1.80258 0.5 2.30775 0.5H17.6923C18.1974 0.5 18.625 0.675 18.975 1.025C19.325 1.375 19.5 1.80258 19.5 2.30775V13.6923C19.5 14.1974 19.325 14.625 18.975 14.975C18.625 15.325 18.1974 15.5 17.6923 15.5H2.30775ZM10 8.39225C10.0833 8.39225 10.166 8.37975 10.248 8.35475C10.3302 8.32975 10.4097 8.2955 10.4865 8.252L17.6385 3.673C17.7525 3.6025 17.8333 3.51117 17.8808 3.399C17.9282 3.28683 17.9423 3.16858 17.923 3.04425C17.9102 2.81342 17.7973 2.64192 17.5845 2.52975C17.3718 2.41758 17.1572 2.4275 16.9405 2.5595L10 7L3.0595 2.5595C2.84283 2.4275 2.62975 2.41692 2.42025 2.52775C2.21058 2.63875 2.09617 2.80767 2.077 3.0345C2.05767 3.16917 2.07175 3.29417 2.11925 3.4095C2.16675 3.525 2.2475 3.61283 2.3615 3.673L9.5135 8.252C9.59033 8.2955 9.66983 8.32975 9.752 8.35475C9.834 8.37975 9.91667 8.39225 10 8.39225Z",
    fill: "#9B1E26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.6478308c5fa514f7fbba9f3f119a6cc6.svg";
export { ForwardRef as ReactComponent };